"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var configuration_1 = require("./configuration");
var mainViewController_1 = require("./mainViewController");
var planeditor_1 = require("./planeditor");
var planeditor_2 = require("./planeditor");
var disabledEditorManager_1 = require("./disabledEditorManager");
var imageProvider_1 = require("./imageProvider");
var treeManager_1 = require("./datalayer/treeManager");
var planeditor_3 = require("./planeditor");
var underlinedTextRender_1 = require("./uiElements/underlinedTextRender");
var FilterLevelCalculator_1 = require("./datalayer/FilterLevelCalculator");
exports.viewsProviderClass = zebra.Class(zebra.ui.grid.DefViews, [
    function (isOnlineApi, options) {
        this.standardFont = new zebra.ui.Font(configuration_1.PlanConfiguration.fontType, configuration_1.PlanConfiguration.fontSize);
        this.boldFont = new zebra.ui.Font(configuration_1.PlanConfiguration.fontType, "bold", configuration_1.PlanConfiguration.fontSize);
        this.disabledEditorManager = new disabledEditorManager_1.DisabledEditorManager();
        if (isOnlineApi === true) {
            this.treeManager = new treeManager_1.TreeManager(isOnlineApi);
        }
        this.warnImage = this.createPanel(imageProvider_1.ImageProvider.getWarningImage());
        this.pencilImage = imageProvider_1.ImageProvider.getPencilSquareImage();
        this.options = options || {};
        this.$super();
    },
    function getColumnBackground(column, value, isPreset) {
        if ((value === undefined || value === configuration_1.PlanConfiguration.ERROR_STRING) &&
            _.get(column, "settings.readonlyWhenUndefined") &&
            !isPreset) {
            return configuration_1.PlanConfiguration.standardTableBackground;
        }
        return (column.settings && column.settings.background) ? column.settings.background : configuration_1.PlanConfiguration.standardTableBackground;
    },
    function generateAdformat(value, standardAdformats) {
        if (this.options.getAdformatInfoString && value !== configuration_1.PlanConfiguration.ERROR_STRING && !this.isOnlineAdformat(value)) {
            return this.options.getAdformatInfoString(value);
        }
        if (_.get(value, "online.adFormat")) {
            value = value.online.adFormat;
        }
        if (value) {
            if (value.currentIndex !== -1) {
                value = value.currentItem ? value.currentItem.name : value.notFoundText;
            }
            else {
                if (standardAdformats) {
                    var theStandardAdf = _.find(standardAdformats, function (cand) {
                        return cand.id === value;
                    });
                    if (theStandardAdf) {
                        return theStandardAdf.name;
                    }
                }
                value = value.notFoundText;
            }
        }
        return value;
    },
    function isOnlineAdformat(value) {
        if (value.notFoundText) {
            return true;
        }
        return false;
    },
    function generateTargetingTree(value) {
        return value !== undefined ? value.keys : value;
    },
    function generateNumeral(value, theColumn) {
        if (!isNaN(value)) {
            var theSettings = theColumn.settings;
            var theNumberFormat = _.get(theSettings, "numberFormat");
            if (theColumn.dataType === planeditor_2.DATA_TYPES.NUMBER || theColumn.dataType === planeditor_2.DATA_TYPES.CURRENCY) {
                var factor = theColumn.settings ? theColumn.settings.factor : undefined;
                if (factor !== undefined) {
                    value *= factor;
                    if (theColumn.settings.alwaysFloor) {
                        value = Math.floor(value);
                    }
                }
            }
            if (theColumn.dataType === planeditor_2.DATA_TYPES.NUMBER || theColumn.dataType === planeditor_2.DATA_TYPES.CURRENCY && theNumberFormat) {
                value = numeral(value).format(theNumberFormat);
            }
        }
        else {
            value = configuration_1.PlanConfiguration.ERROR_STRING;
        }
        return value;
    },
    function generateLink(value, font) {
        if (value !== undefined) {
            var theLink = new zebra.ui.Label(new underlinedTextRender_1.underlinedTextRender(value));
            theLink.setPadding(configuration_1.PlanConfiguration.cellYPadding, configuration_1.PlanConfiguration.cellXPadding, configuration_1.PlanConfiguration.cellYPadding, configuration_1.PlanConfiguration.cellXPadding);
            if (font) {
                theLink.setFont(font);
                theLink.setColor(configuration_1.PlanConfiguration.linkFontColor);
            }
            return new zebra.ui.CompRender(theLink);
        }
        return new zebra.ui.CompRender(new zebra.ui.Label(""));
    },
    function generateButton(grid, row, theColumn) {
        var isReadOnly = (this.rows && this.rows[row].isReadOnly) || false;
        if (!isReadOnly) {
            var textPanel = new zebra.ui.Panel();
            textPanel.setLayout(new zebra.layout.FlowLayout(zebra.layout.CENTER, zebra.layout.TOP));
            var theLabel = new zebra.ui.Label(theColumn.editor.caption);
            theLabel.setColor(configuration_1.PlanConfiguration.textColor);
            textPanel.add(theLabel);
            var theButton = new zebra.ui.Button(textPanel);
            var buttonOffset = -4;
            var buttonSize = Math.min(theColumn.settings.width, grid.getRowHeight(0)) + buttonOffset;
            theButton.setPreferredSize(buttonSize, buttonSize);
            theButton.setBackground(configuration_1.PlanConfiguration.greyButtonBackground);
            return new zebra.ui.CompRender(theButton);
        }
        return new zebra.ui.StringRender("");
    },
    function generateCheckbox(value, isEnabled) {
        var theCheckBox = new zebra.ui.Checkbox(undefined);
        var checkBoxValue = value && isEnabled;
        theCheckBox.setValue(checkBoxValue);
        theCheckBox.setPreferredSize(-1, -1);
        if (isEnabled) {
            theCheckBox.box.setBackground(configuration_1.PlanConfiguration.greyButtonBackground);
        }
        else {
            theCheckBox.box.setBackground(configuration_1.PlanConfiguration.disabledButtonBackground);
        }
        return new zebra.ui.CompRender(theCheckBox);
    },
    function setStandardAdformats(adformats) {
        this.standardAdformats = adformats;
    },
    function setColumnSet(columnSet) {
        this.columns = columnSet.columns.map(function (column) {
            return column || {};
        });
    },
    function createCellComboItemView(editorConfig, value, font, column, width, isActive) {
        var key = value.toString();
        var display;
        if (editorConfig.display && editorConfig.display[key]) {
            display = editorConfig.display[key];
        }
        else {
            display = key;
        }
        if (editorConfig.defaultValue && value === configuration_1.PlanConfiguration.ERROR_STRING) {
            display = editorConfig.defaultValue;
        }
        var theRender = new zebra.ui.TextRender(display);
        theRender.setFont(this.render.font);
        theRender.setColor(configuration_1.PlanConfiguration.tableColor);
        var theValues = new Array();
        theValues.push(display);
        var theValueList = new zebra.ui.List(theValues);
        theValueList["provider"]["text"]["font"] = font;
        theValueList["provider"]["text"]["color"] = configuration_1.PlanConfiguration.tableColor;
        var theCombo = new zebra.ui.Combo(theValueList);
        if (isActive) {
            theCombo.setPreferredSize(column.settings.width || configuration_1.PlanConfiguration.tableDefaultWidth, -1);
            theCombo.setBackground(configuration_1.PlanConfiguration.comboBackground);
            theCombo.setBorder(new zebra.ui.Border(configuration_1.PlanConfiguration.borderColor, 0));
            theCombo.list.select(0);
            theCombo.button.setPreferredSize(configuration_1.PlanConfiguration.comboButtonSize, configuration_1.PlanConfiguration.comboButtonSize);
            theCombo.setPreferredSize(width, -1);
        }
        theCombo.setVisible(isActive);
        return new zebra.ui.CompRender(theCombo);
    },
    function getXAlignment(grid, row, col) {
        var zebraAlignment;
        if (this.columns[col].settings) {
            switch (this.columns[col].settings.xAlign) {
                case planeditor_3.HORIZONTAL_ALIGNMENTS.LEFT:
                    zebraAlignment = zebra.layout.LEFT;
                    break;
                case planeditor_3.HORIZONTAL_ALIGNMENTS.CENTER:
                    zebraAlignment = zebra.layout.CENTER;
                    break;
                case planeditor_3.HORIZONTAL_ALIGNMENTS.RIGHT:
                    zebraAlignment = zebra.layout.RIGHT;
                    break;
                default:
                    zebraAlignment = zebra.layout.LEFT;
            }
        }
        else {
            zebraAlignment = zebra.layout.CENTER;
        }
        return zebraAlignment;
    },
    function getYAlignment(grid, row, col) {
        return zebra.layout.CENTER;
    },
    function makeImageTextPanel(grid, row, col, value, defaultText, font, color, backgroundColor) {
        if (defaultText === void 0) { defaultText = ""; }
        value = value !== undefined ? value : defaultText;
        value = value.toString();
        var theLabel = new zebra.ui.Label(value);
        var labelOffset = -32;
        theLabel.setPreferredSize(grid.getColWidth(col) + labelOffset, -1);
        var defaultData = this.getTextFormat(row, col);
        if (!font) {
            font = defaultData.useBoldFont ? this.boldFont : this.standardFont;
        }
        if (!color) {
            color = defaultData.color;
        }
        theLabel.setFont(font);
        theLabel.setColor(color);
        var imageLabelPeddingLeft = 2;
        theLabel.setPadding(0, imageLabelPeddingLeft, 0, 0);
        var thePanel = new zebra.ui.Panel();
        thePanel.setLayout(new zebra.layout.FlowLayout());
        thePanel.setPadding(0);
        thePanel.add(this.pencilImage);
        thePanel.add(theLabel);
        if (backgroundColor) {
            thePanel.setBackground(backgroundColor);
        }
        return thePanel;
    },
    function createCompRender(value, useBoldFont, color) {
        if (useBoldFont === void 0) { useBoldFont = false; }
        if (!value) {
            value = "";
        }
        var theLabel = new zebra.ui.Label(value.toString());
        if (useBoldFont) {
            theLabel.setFont(this.boldFont);
        }
        else {
            theLabel.setFont(this.standardFont);
        }
        if (color) {
            theLabel.setColor(color);
        }
        theLabel.setColor(configuration_1.PlanConfiguration.tableColor);
        return this.createPanel(theLabel);
    },
    function createPanel(label) {
        var thePanel = new zebra.ui.Panel(new zebra.layout.FlowLayout());
        thePanel.setPadding(configuration_1.PlanConfiguration.cellYPadding, configuration_1.PlanConfiguration.cellXPadding, configuration_1.PlanConfiguration.cellYPadding, configuration_1.PlanConfiguration.cellXPadding);
        thePanel.add(label);
        return new zebra.ui.CompRender(thePanel);
    },
    function formatValueAccordingToDataType(column, value, row) {
        switch (column.dataType) {
            case planeditor_2.DATA_TYPES.NUMBER:
            case planeditor_2.DATA_TYPES.CURRENCY:
                value = this.generateNumeral(value, column);
                break;
            case planeditor_2.DATA_TYPES.BOOLEAN:
                return { newValue: this.generateCheckbox(value, this.disabledEditorManager.isEnabled(column, row)), isEditor: true };
            case planeditor_2.DATA_TYPES.LINK:
                var theLink = this.generateLink(value, this.standardFont);
                return { newValue: theLink, isEditor: true };
            case planeditor_2.DATA_TYPES.IMAGE:
                if (value) {
                    return { newValue: this.warnImage, isEditor: true };
                }
                break;
            default:
                if (value === undefined) {
                    var textOnEmpty = _.get(column, "settings.textOnEmpty");
                    value = textOnEmpty !== undefined ? textOnEmpty : configuration_1.PlanConfiguration.ERROR_STRING;
                }
        }
        return { newValue: value, isEditor: false };
    },
    function isReadOnly(row) {
        return (this.rows && this.rows[row].isReadOnly) || false;
    },
    function getReadOnlyPanel(column, row, value) {
        if (value === configuration_1.PlanConfiguration.ERROR_STRING || typeof value !== "string") {
            return new zebra.ui.StringRender("");
        }
        else if (typeof value === "string") {
            return this.createCompRender(value, true);
        }
        return undefined;
    },
    function getEditorCompRender(column, grid, row, col, value, mediumType) {
        if (!column.editor) {
            return;
        }
        switch (column.editor.type) {
            case planeditor_1.COLUMN_EDITORS.AD_FORMAT:
                if (mediumType === "Outdoor") {
                    return undefined;
                }
                var adFormatLabel = void 0;
                if (this.getProprietaryName(row)) {
                    adFormatLabel = this.makeImageTextPanel(grid, row, col, this.getProprietaryName(row));
                }
                else {
                    value = this.generateAdformat(value, this.standardAdformats) || "";
                    if (this.rows && this.rows[row].adformatState === mainViewController_1.rowState.Warning) {
                        adFormatLabel = this.makeImageTextPanel(grid, row, col, value, "", this.boldFont, configuration_1.PlanConfiguration.warningFontColor, configuration_1.PlanConfiguration.warningRow, configuration_1.PlanConfiguration.warningRow);
                    }
                    else {
                        adFormatLabel = this.makeImageTextPanel(grid, row, col, value);
                    }
                }
                return this.createPanel(adFormatLabel);
            case planeditor_1.COLUMN_EDITORS.TARGETING:
                if (this.isReadOnly(row)) {
                    value = configuration_1.PlanConfiguration.ERROR_STRING;
                    break;
                }
                value = this.generateTargetingTree(value);
                if (_.isArray(value)) {
                    value = value.length === 0 ? column.editor.config.textOnEmpty : this.treeManager.getShortDescriptions(value);
                }
                var targetingLabel = this.makeImageTextPanel(grid, row, col, value, column.editor.config.textOnEmpty);
                return this.createPanel(targetingLabel);
            case planeditor_1.COLUMN_EDITORS.SPECIAL_PRICE:
                if (this.isReadOnly(row)) {
                    value = configuration_1.PlanConfiguration.ERROR_STRING;
                    break;
                }
                var specialPriceLabel = this.makeImageTextPanel(grid, row, col, value.description, column.editor.config.textOnEmpty);
                return this.createPanel(specialPriceLabel);
            case planeditor_1.COLUMN_EDITORS.BUTTON:
                return this.generateButton(grid, row, column);
            case planeditor_1.COLUMN_EDITORS.PERIOD:
                var text = _.get(value, "content.ownTitle") || _.get(value, "attributes.title");
                var periodLabel = this.makeImageTextPanel(grid, row, col, text, column.editor.config.textOnEmpty);
                return this.createPanel(periodLabel);
            case planeditor_1.COLUMN_EDITORS.DROP_DOWN:
                var fontToUse = this.standardFont;
                if (this.isReadOnly(row)) {
                    value = configuration_1.PlanConfiguration.ERROR_STRING;
                    fontToUse = this.boldFont;
                }
                var width = grid.getColWidth(col);
                var isActive = true;
                return this.createCellComboItemView(column.editor.config, value, fontToUse, column, width, isActive);
            case planeditor_1.COLUMN_EDITORS.CHECKBOX:
                return this.$super.apply(this, arguments);
            default:
        }
    },
    function getTextFormat(row, col) {
        var useBoldFont = false;
        var color = configuration_1.PlanConfiguration.tableColor;
        if (this.rows) {
            var theColumn = this.columns[col];
            var theRowState = this.rows[row].rowState;
            if ((theRowState === mainViewController_1.rowState.Error && _.get(theColumn, "settings.highlightOnError")) ||
                (theRowState === mainViewController_1.rowState.ErrorMissed67 && _.get(theColumn, "settings.highlightOnMissed67"))) {
                color = configuration_1.PlanConfiguration.errorFontColor;
                useBoldFont = true;
            }
            else if (theRowState === mainViewController_1.rowState.Warning && theColumn.settings && _.get(theColumn, "settings.highlightOnWarning")) {
                color = configuration_1.PlanConfiguration.warningFontColor;
                useBoldFont = true;
            }
            else if (this.isReadOnly(row)) {
                useBoldFont = true;
            }
        }
        return { color: color, useBoldFont: useBoldFont };
    },
    function getView(grid, row, col, value) {
        var theColumn = this.columns[col];
        if (_.get(theColumn, "settings.showOnPresetRow") === false && grid["isPresetRow"]) {
            return;
        }
        var mediumType;
        if (this.rows) {
            var theRow = this.rows[row];
            var minLevel = _.get(theColumn, "settings.level");
            if (minLevel) {
                var thisLevel = FilterLevelCalculator_1.FilterLevelCalculator.calculateLevel(_.get(theRow, "rawSample"), this._limitValue);
                if (thisLevel < minLevel) {
                    return this.createCompRender(configuration_1.PlanConfiguration.limitationText);
                }
            }
            var columnTypes = _.get(theColumn, "types");
            mediumType = _.get(theRow, "medium.tariffConditionId");
            if (columnTypes && mediumType) {
                if (columnTypes.indexOf(mediumType.toString().toLowerCase()) === -1) {
                    return undefined;
                }
            }
        }
        var valueAccordingToDataType = this.formatValueAccordingToDataType(theColumn, value, row);
        if (valueAccordingToDataType.isEditor) {
            return valueAccordingToDataType.newValue;
        }
        else {
            value = valueAccordingToDataType.newValue;
        }
        var isReadOnly = this.isReadOnly(row);
        if (isReadOnly && !theColumn.isGroupColumn) {
            var readOnlyPanel = this.getReadOnlyPanel(theColumn, row, value);
            if (readOnlyPanel) {
                return readOnlyPanel;
            }
        }
        var editorCompRender = this.getEditorCompRender(theColumn, grid, row, col, value, mediumType);
        if (editorCompRender) {
            return editorCompRender;
        }
        var textFormat = this.getTextFormat(row, col);
        value = this.handleMissed67onText(row, theColumn, value);
        return this.createCompRender(value, textFormat.useBoldFont, textFormat.color);
    },
    function handleMissed67onText(row, column, value) {
        if (this.rows && this.rows[row].rowState === mainViewController_1.rowState.ErrorMissed67 && _.get(column, "settings.showAlternativeTextOnMissed67") === true) {
            _.set(this.rows[row], "missed67text", configuration_1.PlanConfiguration.missed67longMessage);
            return configuration_1.PlanConfiguration.missed67shortMessage;
        }
        return value;
    },
    function getProprietaryName(row) {
        if (this.rows && this.rows[row] && _.get(this.rows[row], "additionalData.specialPriceData.proprietaryName")) {
            return _.get(this.rows[row], "additionalData.specialPriceData.proprietaryName");
        }
        else {
            return undefined;
        }
    },
    function getCellColor(grid, row, col) {
        if (_.contains(grid["selectedRows"], row)) {
            return;
        }
        if (this.rows) {
            var theRow = this.rows[row];
            var theCol = this.columns[col];
            if (theRow.rowState === mainViewController_1.rowState.Error || theRow.rowState === mainViewController_1.rowState.ErrorMissed67) {
                return configuration_1.PlanConfiguration.corruptedRow;
            }
            else if (theRow.rowState === mainViewController_1.rowState.Warning) {
                return configuration_1.PlanConfiguration.warningRow;
            }
            else if (theRow.adformatState === mainViewController_1.rowState.Warning && theCol.key === "AD_FORMAT") {
                return configuration_1.PlanConfiguration.warningRow;
            }
            else if (theRow.isReadOnly) {
                return configuration_1.PlanConfiguration.groupRow;
            }
        }
        if (this.columns) {
            var theValue = grid.model.get(row, col);
            return this.getColumnBackground(this.columns[col], theValue, grid["isPresetRow"]);
        }
    },
    function setCheckboxEnabled(grid, row, path, state) {
        this.disabledEditorManager.setEditorEnabled(grid, row, path, state);
    },
    function setLimitValue(value) {
        this._limitValue = value;
    }
]);
//# sourceMappingURL=CellViewProvider.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/CellViewProvider.js
// module id = 29
// module chunks = 0